// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IMessageOfferSchema } from '../offer/MessageOfferSchema';

export interface IMessageSchema {
  /** признак, что сообщение может быть удалено **/
  canBeDeleted?: boolean;
  /** Дата создания сообщения в ISO формате **/
  created: string;
  /** Признак того, что автор сообщения - бот **/
  fromChatBot: boolean;
  /** признак, что сообщение отправлено из crm **/
  fromCrm?: boolean;
  /** Изображения **/
  images?: string[];
  /** Идентификатор сообщения **/
  messageId: string;
  /** Объявления; У сообщения может быть только одно объявление; Здесь лежит список из одного элемента **/
  offers?: IMessageOfferSchema[];
  /** Версия изменений **/
  rowVersion: number;
  /** Статус сообщения **/
  status: EStatus;
  /** Текст сообщения **/
  text?: string;
  /** Тип сообщения **/
  type: EType;
}
export enum EStatus {
  /** Удалено **/
  'Deleted' = 'deleted',
  /** Доставлено до сервера **/
  'DeliveredToServer' = 'deliveredToServer',
}
export enum EType {
  /** Сообщение с оффером **/
  'Offer' = 'offer',
  /** Текстовое сообщение **/
  'Text' = 'text',
  /** Сообщение с текстом и картинкой **/
  'TextAndImages' = 'textAndImages',
}
